import React from 'react'
import { RectangleVertical } from 'lucide-react'

export default function PanelToggleOnePanelIcon() {
    return <RectangleVertical width={18} height={18} />
}
